import { PAGE_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const USER: AppRouteRecordRaw = {
    path: '/bigscreen',
    name: 'bigscreen',
    component: PAGE_LAYOUT,
    meta: {
        locale: 'menu.monitor',
        icon: 'icon-storage',
        requiresAuth: true,
        order: 2,
    },
    children: [
        {
            path: '/bigscreen/station',
            name: 'big-screen-station',
            component: () => import('@/views/bigscreen/station/index.vue'),
            meta: {
                target: '_blank',
                locale: 'menu.monitor',
                requiresAuth: true,
                roles: ['*'],
            },
        },
        {
            path: '/bigscreen/station-v2',
            name: 'big-screen-station-v2',
            component: () => import('@/views/bigscreen/station-v2/index.vue'),
            meta: {
                target: '_blank',
                locale: 'menu.monitor',
                requiresAuth: true,
                roles: ['*'],
            },
        },
    ],
};

export default USER;
